<template>
    <div>
        <b-row align-h="center" class="my-3">
            <b-button class="yonOk" @click="haftaGeriGit()">&lsaquo;</b-button>
            <p class="tarihlerArasiText">{{tarihlerArasi}}</p>
            <b-button class="yonOk" @click="haftaIleriGit()">&rsaquo;</b-button>
        </b-row>
        
        <div class="container">
            <b-form-select v-model="tur" class="mb-3">
                <b-form-select-option value="mektup">Mektup</b-form-select-option>
                <b-form-select-option value="kart">Kart</b-form-select-option>
            </b-form-select>
            
            <b-alert variant="success" show>{{hedefeUlasanlar}} kişi hedefe ulaşmış. </b-alert>
            <b-alert variant="warning" show>{{hedefeUlasamayanlar}} kişi hedefe ulaşamamış. </b-alert>
            <b-alert variant="danger" show>{{hicYapmayanlar}} kişi hiç yapmamış. </b-alert>

            <b-button
                    v-if="tur === 'kart'"
                    class="mb-1"
                    block
                    style="background-color: #491217;"
                    @click="hicYapmayanKisilereGit(KisiFiltre.karttaHicYapmayanlar)" >
                {{vazifesiniHicYapmayanKisiSayisi}} kişi <u>şuana kadar hiç</u> yapmamış.
            </b-button>

            <b-button
                    v-if="tur === 'kart'"
                    class="mb-1"
                    block
                    @click="hicYapmayanKisilereGit(KisiFiltre.karttaDortHaftadirYapmayanlar)"
                    variant="danger"
            >
                {{vazifesiniDortHaftadirYapmayanKisiSayisi}} kişi <u>dört haftadır hiç</u> yapmamış.
            </b-button>
            
            <b-table :busy="isBusy" class="table-responsive-sm" striped hover
                     sort-by="bitenBelgeSayisi"
                     sort-desc
                     :items="liste" :fields="fields">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Rapor Oluşturuluyor...</strong>
                    </div>
                </template>
                <template v-slot:cell(bitenBelgeSayisi)="data">
                    <span v-if="data.item.bitenBelgeSayisi >= 7" style="color: green;">{{data.item.bitenBelgeSayisi}}</span>
                    <span v-else-if="data.item.bitenBelgeSayisi === 0" style="color: darkorange;">{{data.item.bitenBelgeSayisi}}</span>
                    <span v-else style="color: red;">{{data.item.bitenBelgeSayisi}}</span>
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import {
        KisiBazliHaftalikRapor,
        VazifesiniHicYapmayanKisiSayisi,
        VazifesiniYapmayanKisiSayisi
    } from "@/api/belgeler";
    import {KisiFiltre} from "@/utils/kisiFiltre";
    
    export default {
        name: "KisiBazliHaftalikRapor",
        data() {
            return {
                KisiFiltre,
                vazifesiniHicYapmayanKisiSayisi: 0,
                vazifesiniDortHaftadirYapmayanKisiSayisi: 0,
                tur: 'mektup',
                iterasyondaKaldigiTarih: moment().subtract(3, 'days'),
                tarihlerArasi: '',
                tarihBaslangicZaman: '',
                isBusy: false,
                hedefeUlasanlar: 0,
                hedefeUlasamayanlar: 0,
                hicYapmayanlar: 0,
                liste: [],
                fields: [
                    {
                        key: 'isim',
                        label: 'İsim',
                        sortable: true
                    },
                    {
                        key: 'il',
                        label: 'İl',
                        sortable: true
                    },
                    {
                        key: 'ilce',
                        label: 'İlçe',
                        sortable: true
                    },
                    {
                        key: 'bitenBelgeSayisi',
                        label: 'Bitirilen Belge Sayısı',
                        sortable: true,
                    },
                ],
                baslangicTarih: '',
                bitisTarih: ''
            }
        },
        watch: {
          'tur': async function() {
              await this.tariheGoreVerileriGetir()
          }  
        },
        methods: {
            hicYapmayanKisilereGit(filtre) {
              this.$router.push({ name: 'kisiler', query: { filtre: filtre } })
            },
            haftayiHesapla() {
                const bugundenCikar = moment().subtract(3, 'days')

                const pazartesi = moment(bugundenCikar).startOf('isoWeek')
                const haftayaPazartesi = moment(pazartesi.toDate()).add(7, 'days')

                this.baslangicTarih = pazartesi
                this.bitisTarih = haftayaPazartesi
                
                this.tarihBaslangicZaman = pazartesi.format("YYYY-MM-DD")

                this.tarihlerArasiniGuncelle()

                this.tariheGoreVerileriGetir()
            },
            tarihlerArasiniGuncelle() {
                this.tarihlerArasi = ''
                this.tarihlerArasi += this.baslangicTarih.format("DD-MM-YYYY")
                this.tarihlerArasi += " ile "
                this.tarihlerArasi += this.bitisTarih.format("DD-MM-YYYY")
            },
            haftaGeriGit() {
                const pazartesi = moment(this.iterasyondaKaldigiTarih).startOf('isoWeek')
                const gecenPazartesi = moment(pazartesi.toDate()).subtract(7, 'days')
                
                this.iterasyondaKaldigiTarih = gecenPazartesi.toDate();

                this.baslangicTarih = gecenPazartesi
                this.bitisTarih = pazartesi
                
                this.tarihlerArasiniGuncelle()
                this.tariheGoreVerileriGetir()
            },
            haftaIleriGit() {
                const pazartesi = moment(this.iterasyondaKaldigiTarih).startOf('isoWeek')
                const baslangic = moment(pazartesi.toDate()).add(7, 'days')
                const bitis = moment(baslangic.toDate()).add(7, 'days')
                this.iterasyondaKaldigiTarih = baslangic.toDate();

                this.baslangicTarih = baslangic
                this.bitisTarih = bitis
                
                this.tarihlerArasiniGuncelle()
                this.tariheGoreVerileriGetir()
            },
            async tariheGoreVerileriGetir() {
                this.hedefeUlasanlar = 0
                this.hedefeUlasamayanlar = 0
                this.hicYapmayanlar = 0
                this.vazifesiniHicYapmayanKisiSayisi = 0;
                this.vazifesiniDortHaftadirYapmayanKisiSayisi = 0;
                
                this.isBusy = true
                const { data } = await KisiBazliHaftalikRapor(this.tur, 
                    this.baslangicTarih.format('YYYY-MM-DD'), this.bitisTarih.format('YYYY-MM-DD'))
                
                this.hedefeUlasanlar = data.hedefeUlasanlar
                this.hedefeUlasamayanlar = data.hedefeUlasamayanlar
                this.hicYapmayanlar = data.hicYapmayanlar
                this.liste = data.istatistikler
                
                const { data: kartOperatorleri } = await VazifesiniYapmayanKisiSayisi()
                this.vazifesiniHicYapmayanKisiSayisi = kartOperatorleri.hicYapmayanKisiSayisi
                this.vazifesiniDortHaftadirYapmayanKisiSayisi = kartOperatorleri.dortHaftadirYapmayanKisiSayisi
                this.isBusy = false 
            },
        },
        created() {
            this.haftayiHesapla()
        }
    }
</script>

<style scoped>

    .tarihlerArasiText {
        margin: auto 0px;
        padding-left: 5px;
        padding-right: 5px;
    }
    
    .tarihlerArasiText,
    .yonOk {
        font-size: 1.5em;
    }

    .yonOk {
        color: black;
        font-weight: bold;
        background-color: #bee5eb;
    }
</style>